<template>
    <Table :columns="columns" :data="ajaxData" ref="table" max-height="700" :show-summary="showSummary"
           sum-text="总计"></Table>
</template>
<script>
    export default {
        name: "UserGetTable",
        props: {
            ajaxData: Array,
            columns: {
                type: Array,
                default: () => [
                    {
                        title: '日期',
                        key: 'date'
                    },
                    {
                        title: '新增启动数',
                        key: 'new_active_add'
                    },
                    {
                        title: '新增注册数',
                        key: 'new_register_add'
                    },
                    {
                        title: '转化率',
                        key: 'change_percent'
                    },
                    {
                        title: '非邀请新增',
                        key: 'not_invite_add'
                    },
                    {
                        title: '邀请新增',
                        key: 'invite_add'
                    }
                ]
            },
            showSummary: {
                type: Boolean,
                default: false
            },

        },
        data() {
            return {
                columns1: [
                    {
                        title: '日期',
                        key: 'date'
                    },
                    {
                        title: '新增启动数',
                        key: 'new_active_add'
                    },
                    {
                        title: '新增注册数',
                        key: 'new_register_add'
                    },
                    {
                        title: '转化率',
                        key: 'change_percent'
                    },
                    {
                        title: '非邀请新增',
                        key: 'not_invite_add'
                    },
                    {
                        title: '邀请新增',
                        key: 'invite_add'
                    }
                ],
                data1: [
                    {
                        date: '2016-10-03',
                        new_active_add: '200',
                        new_register_add: '123',
                        change_percent: '87%',
                        not_invite_add: '434',
                        invite_add: '322',
                    },
                    {
                        date: '2016-10-01',
                        new_active_add: '200',
                        new_register_add: '123',
                        change_percent: '87%',
                        not_invite_add: '434',
                        invite_add: '322',
                    },
                    {
                        date: '2016-10-02',
                        new_active_add: '200',
                        new_register_add: '123',
                        change_percent: '87%',
                        not_invite_add: '434',
                        invite_add: '322',
                    },
                    {
                        date: '2016-10-04',
                        new_active_add: '200',
                        new_register_add: '123',
                        change_percent: '87%',
                        not_invite_add: '434',
                        invite_add: '322',
                    }
                ]
            }
        },
        methods: {
            exportData() {
                this.$refs.table.exportCsv({
                    filename: 'The original data'
                })
            }
        }
    }
</script>

<style scoped>

</style>
